import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { getUser, isLoggedIn } from "../services/auth"
import Layout from "../components/layout"

export default function Home() {
    const [iphoneDate, setIphoneDate] = useState("")
    const [macbookDate, setMacbookDate] = useState("")
    const [watchDate, setWatchDate] = useState("")

    useEffect(() => {
        // NOTE: if dev must disable web security for cors to allow this
        fetch(`https://dw-front-end-interview.herokuapp.com/api/shipping-dates`
        ).then(response => response.json()) // parse JSON from request
            .then(resultData => {
                // console.error('data:', resultData);
                setIphoneDate(resultData.iphone)
                setMacbookDate(resultData.mackbook)
                setWatchDate(resultData.watch)
            }).catch((error) => {
                console.error('Error:', error);
                let jsonStub = {
                    "iphone": "2020/02/21",
                    "mackbook": "2020/08/04",
                    "watch": "2020/11/16"
                }
                setIphoneDate(jsonStub.iphone)
                setMacbookDate(jsonStub.mackbook)
                setWatchDate(jsonStub.watch)
            });
    }, [])

    return (
        <Layout>
            <p>iphone:  {iphoneDate}</p>
            <p>macbook: {macbookDate}</p>
            <p>watch:   {watchDate}</p>
            <h1>{isLoggedIn() ? "Hello " + getUser().name + "!" : null}</h1>
            <p>
                {isLoggedIn() ? (
                    <>
                        You are logged in, so check your{" "}
                        <Link to="/app/profile">profile</Link>
                    </>
                ) : (
                    <>
                        You should <Link to="/app/login">log in</Link> to see restricted
                        content or <Link to="/app/signup">Sign up</Link>
                    </>
                )}
            </p>
        </Layout>
    )
}
